export default {
  title: {
    interview: 'Interview Scheduler'
  },
  label: {
    information: 'Interview Information: ',
    company: 'Company',
    job: 'Job',
    organizer: 'Organizer',
    interviewer: 'Interviewer',
    candidate: 'Candidate',
    status: 'Status',
    selectTime: 'Please select a time: ',
    scheduled: 'Interview Time: ',
    cancelInterview: 'Do you confirm to cancel the interview?',
    suggestInterview: 'If none of these times work, click confirm and we\'ll request new interview times from the interviewer.',
    suggestedNewTime: 'New interview times requested',
    canceled: 'Interview canceled'
  },
  btn: {
    suggestTime: 'None of These Times Work'
  },
  message: {
    selectTime: 'Please select a time',
    confirmSuccess: 'Interview scheduled',
    cancelSuccess: 'Interview canceled',
    suggestSuccess: 'New interview times proposed'
  }
}
